import * as o from "react";
import s from "../lib/IconBase.es.js";
import t from "../defs/ArrowClockwise.es.js";
const r = o.forwardRef((e, c) => /* @__PURE__ */ o.createElement(s, { ref: c, ...e, weights: t }));
r.displayName = "ArrowClockwiseIcon";
const m = r;
export {
  m as ArrowClockwise,
  r as ArrowClockwiseIcon
};
